<template>
  <div id="app">
      <div class="nav-btn" v-on:click="openMenu()">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="circle"></div>
      <nav class="slideRight">
        <ul>
          <li v-on:click="openPage()">
            <router-link data-text="Home" to="/">Home</router-link>
          </li>
          <li v-on:click="openPage()">
            <router-link data-text="Resume" to="/about">Resume</router-link>
          </li>
          <li v-on:click="openPage()">
            <router-link data-text="Portfolio" to="/portfolio">Portfolio</router-link>
          </li>
          <li v-on:click="openPage()">
            <router-link data-text="Contact" to="/contact">Contact</router-link>
          </li>
        </ul>
      </nav>
      <a href="mailto:me@keyhan.info" target="_blank" class="email">me@Keyhan.info</a>
      <span class="itsfast">" isn't it fast? :) "</span>
    <router-view class="mainview fadeIn" />
    <div class="social-icons">
      <social-icons />
    </div>
  </div>
</template>

<script>
import socialIcons from '@/components/SocialIcons'

export default {
  components: {
    socialIcons
  },
  methods: {
    openMenu() {
      document.querySelector('.circle').classList.toggle('active');
      document.querySelector('.nav-btn').classList.toggle('active');
      document.querySelector('nav').classList.toggle('active');
      document.querySelector('.email').classList.toggle('active');
      document.querySelector('.itsfast').classList.toggle('active');
    },
    openPage(className) {
      if(className === 'white-mode') {
        document.querySelector('body').classList.add(className);
      } else {
        document.querySelector('body').classList.remove('white-mode');
      }
      this.openMenu();
    }
  }
}
</script>

<style lang="scss">
@import './styles/app';

.email {
  position: fixed;
  left: -17px;
  top: 170px;
  text-transform: uppercase;
  transform: rotate(-90deg);
  color: $white;
  text-decoration: none;
  font-size: 13px;
  letter-spacing: 2px;
  opacity: 0.3;
  z-index: 100;

  &.active {
    left: -7px;
  }

  &:hover {
    opacity: 1;
  }
}

.itsfast {
  position: absolute;
  bottom: 20px;
  right: 20px;
  letter-spacing: 1px;
  font-size: 13px;
  opacity: 0;
  transform: translateX(200px);
  z-index: 101;
  color: $cyan;

  &.active {
    opacity: 0.3;
    transform: translateX(0);
  }

  &:hover {
    opacity: 1;
  }
}

.social-icons {
  position: absolute;
  bottom: 25px;
  left: 0;
  right: 0;
  z-index: 1000;
}

</style>
